<template>
  <form class="app-form" @submit.prevent>
    <AppFormField v-for="field in fields"
      :key="field.key"
      :width="field.width"
    >
      <component :is="getInputComponent(field)"
        :value="field.value"
        :name="field.key"
        @input="onFieldUpdate({ key: field.key, value: $event })"
        @change="onFieldUpdate({ key: field.key, value: $event })"
      >
        <AppFormLabel v-if="field.label"
          :required="field.isRequired"
          :invalid="shouldShowError(field)"
          v-html="field.label"
        />
      </component>
    </AppFormField>
  </form>
</template>

<script>
import AppFormField from '@/components/AppFormField.vue';
import AppFormLabel from '@/components/AppFormLabel.vue';
import AppFormInputText from '@/components/AppFormInputText.vue';
import AppFormInputTextarea from '@/components/AppFormInputTextarea.vue';
import AppFormInputComment from '@/components/AppFormInputComment.vue';
import AppFormInputCheckbox from '@/components/AppFormInputCheckbox.vue';

export const FIELD_TYPE_TEXT = Symbol('FIELD_TYPE_TEXT');
export const FIELD_TYPE_TEXTAREA = Symbol('FIELD_TYPE_TEXTAREA');
export const FIELD_TYPE_EMAIL = Symbol('FIELD_TYPE_EMAIL');
export const FIELD_TYPE_COMMENT = Symbol('FIELD_TYPE_COMMENT');
export const FIELD_TYPE_CHECKBOX = Symbol('FIELD_TYPE_CHECKBOX');

export default {
  name: 'AppForm',

  components: {
    AppFormField,
    AppFormLabel,
  },

  props: {
    fields: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      shouldShowErrors: false,
    };
  },

  methods: {
    getInputComponent({ type }) {
      switch (type) {
        case FIELD_TYPE_TEXT:
        case FIELD_TYPE_EMAIL:
          return AppFormInputText;
        case FIELD_TYPE_TEXTAREA:
          return AppFormInputTextarea;
        case FIELD_TYPE_COMMENT:
          return AppFormInputComment;
        case FIELD_TYPE_CHECKBOX:
          return AppFormInputCheckbox;
      }
    },

    isFieldValid({ /* key, */ value, type, isRequired }) {
      switch (type) {
        case FIELD_TYPE_TEXT:
        case FIELD_TYPE_TEXTAREA:
          return isRequired ? !!value : true;
        case FIELD_TYPE_CHECKBOX:
          return isRequired ? value : true;
        case FIELD_TYPE_COMMENT:
          return true;
        case FIELD_TYPE_EMAIL:
          return isRequired ? /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
            .test(value) : !value;
        default:
          throw new TypeError(`Unsupported field type ${type}`);
      }
    },

    onFieldUpdate({ key, value }) {
      this.$emit('update', { key, value });
    },

    shouldShowError(field) {
      const { shouldShowErrors } = this;

      if (!shouldShowErrors) {
        return false;
      }

      return !this.isFieldValid(field);
    },

    validate() {
      this.shouldShowErrors = true;

      return Object.values(this.fields)
        .every(field => this.isFieldValid(field));
    },
  },
};
</script>

<style lang="scss">
.app-form {
  display: flex;
  flex-wrap: wrap;

  padding: 0.5em;

  font-family: 'Anton', Arial, Helvetica, sans-serif;
  font-size: font(18px, 24px);
  line-height: 1.25em;
}
</style>
